"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lceTransform = void 0;
const models_1 = require("./models");
// Overload implementation. Hidden to callers.
function lceTransform(lce, transformer) {
    switch (lce.type) {
        case models_1.LCEType.NotRequested:
            return lce;
        case models_1.LCEType.Fetching: {
            const previousContent = lce.previousContent ? lceTransform(lce.previousContent, transformer) : undefined;
            if (previousContent) {
                return {
                    type: models_1.LCEType.Fetching,
                    previousContent,
                };
            }
            else {
                return lce;
            }
        }
        case models_1.LCEType.Error: {
            const previousContent = lce.previousContent ? lceTransform(lce.previousContent, transformer) : undefined;
            if (previousContent) {
                return {
                    type: models_1.LCEType.Error,
                    error: lce.error,
                    previousContent,
                    occurredOnMS: lce.occurredOnMS,
                };
            }
            else {
                return lce;
            }
        }
        case models_1.LCEType.Content:
            return {
                type: models_1.LCEType.Content,
                data: transformer(lce.data),
                lastFetchedMS: lce.lastFetchedMS,
                cacheTimeInMS: lce.cacheTimeInMS,
            };
    }
}
exports.lceTransform = lceTransform;
//# sourceMappingURL=transform.js.map